import { useFormik } from "formik";
import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Progress,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";

import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload, UploadProps } from "antd";
import FoodDrinkApi from "api/foodDrinkApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import IconDeltete from "../../../../assets/images/icon-delete.png";
import { createPathCloudFrame, putUpload } from "api/uploadApi";

export default function CreateEditFoodDrink({
  setIsOpen,
  item,
  setItemToEdit,
  loadTableData,
  setLinkImage,
  barID,
}: any) {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingUploadImage, setIsLoadingUploadImage] =
    useState<boolean>(false);

  const isEdit = item;
  console.log(item);

  const props: UploadProps = {
    name: "files",
    beforeUpload: () => false,
    headers: {
      authorization: "authorization-text",
    },
  };

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading((_prev) => true);
      const ko_translation = item?.translations?.filter(
        (i: any) => i?.lang == "ko"
      )?.[0];
      const ko_price = item?.prices?.filter((i: any) => i?.unit == "₩")?.[0];

      const data = {
        bar_id: barID,
        type: 1, // 1 food, 2 drink
        files: values?.files?.map((i: any) => i?.url),
        translations: [
          {
            ...(ko_translation?.id && {
              id: ko_translation?.id,
            }),
            lang: "ko",
            name: values?.name,
            description: values?.name,
          },
        ],
        prices: [
          {
            ...(ko_price?.id && {
              id: ko_price?.id,
            }),
            unit: "₩",
            price: Number(values?.price),
          },
        ],
      };

      const response: any = isEdit
        ? await FoodDrinkApi?.updateFoodDrink(item?.id, data)
        : await FoodDrinkApi?.createFoodDrink(data);
      if (response?.data) {
        //  dispatch(onGetFoodDrinks(query));
        loadTableData();
        setIsLoading((_prev) => false);
        setIsOpen(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsLoading(false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading(false);
      toast(`Please re-check your data`);
      return error;
    }
  };

  const validationSchema = Yup.object({
    name: Yup.string()
      .nullable()
      .required(`${t("This field is required")}`),
    price: Yup.string().required(`${t("This field is required")}`),
    files: Yup.array()
      .min(1, `${t("This field is required")}`)
      .required(`${t("This field is required")}`),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      price: "",
      files: null,
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if (item) {
      console.log(item);
      const formatedFile = item?.files?.map((i: any) => {
        return {
          uid: "-1",
          name: "image.png",
          url: i,
          thumbUrl: i,
          ...i,
        };
      });
      formik.setFieldValue("files", formatedFile);
      formik.setFieldValue(
        "name",
        item?.translations?.filter((i: any) => i?.lang == "ko")?.[0]?.name
      );
      formik.setFieldValue(
        "price",
        item?.prices?.filter((i: any) => i?.unit == "₩")?.[0]?.price
      );
    }
  }, [item]);

  const onCloseClick = () => {
    setIsOpen(false);
    setItemToEdit(false);
  };

  return (
    <Modal isOpen={true} centered={true} scrollable={false} size="lg">
      <ModalHeader toggle={isLoading ? () => {} : onCloseClick}>
        {isEdit ? t("Button Update") : t("Button Create")}
      </ModalHeader>
      <ModalBody className="py-3 px-4">
        <div className="mb-4">
          <Progress
            value={100 - (100 / 2) * Number(Object.keys(formik.errors).length)}
            color="primary"
            className="animated-progress progress-sm"
          />
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="row g-3">
            <Col xxl={12} className="mt-2">
              <label className="form-label">{t("Name")}</label>
              <input
                className="form-control"
                id="name"
                name="name"
                value={formik?.values?.name}
                placeholder={`${t("Enter the name")}...`}
                onChange={(event: any) =>
                  formik.setFieldValue("name", event?.target?.value || "")
                }
              />
              {formik.touched.name && formik.errors.name ? (
                <div className="text-danger mt-2">{formik.errors.name}</div>
              ) : null}
            </Col>

            <Col xxl={12} className="mt-2">
              <label className="form-label">{`${t("Price")} (₩)`}</label>
              <input
                className="form-control"
                id="price"
                name="price"
                type="number"
                value={formik?.values?.price}
                placeholder={`${t("Enter the price")}...`}
                onChange={(event: any) =>
                  formik.setFieldValue("price", event?.target?.value || "")
                }
              />
              {formik.touched.price && formik.errors.price ? (
                <div className="text-danger mt-2">{formik.errors.price}</div>
              ) : null}
            </Col>

            <Col xxl={6}>
              <label className="form-label">
                {t("Files")}
                <span className="text-danger"> *</span>
              </label>

              {formik.getFieldProps("files")?.value && (
                <div
                  className="overflow-x-auto color-scrollbar-os scrollbar-feed-thumbnail"
                  style={{
                    display: "flex",
                    gap: 10,
                    marginBottom: 10,
                    paddingTop: 10,
                  }}
                >
                  {formik
                    .getFieldProps("files")
                    ?.value?.map((i: any, index: number) => {
                      if (i?.type == "video")
                        return (
                          <div
                            style={{
                              position: "relative",
                              height: "100%",
                              cursor: "pointer",
                            }}
                          >
                            <video
                              width="160"
                              height="120"
                              controls
                              key={i?.url}
                              onClick={() => {
                                setLinkImage({
                                  url: i?.url,
                                  isVideo: true,
                                });
                              }}
                            >
                              <source src={i?.url} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                            <span
                              onClick={() => formik.setFieldValue("files", [])}
                              style={{
                                color: "red",
                                position: "absolute",
                                top: "-14px",
                                right: "-8px",
                                cursor: "pointer",
                              }}
                            >
                              <img
                                src={IconDeltete}
                                alt="delete"
                                width={18}
                                height={18}
                              />
                            </span>
                          </div>
                        );
                      else
                        return (
                          <div
                            style={{
                              position: "relative",
                            }}
                          >
                            <img
                              alt="thumbnail"
                              src={i?.url}
                              style={{
                                maxHeight: 120,
                                maxWidth: 160,
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setLinkImage({ url: i?.url });
                              }}
                            />
                            <span
                              onClick={() => {
                                const newFilesList = [
                                  ...formik.getFieldProps("files")?.value,
                                ];
                                newFilesList.splice(index, 1);
                                formik.setFieldValue("files", newFilesList);
                              }}
                              style={{
                                color: "red",
                                position: "absolute",
                                top: "-12px",
                                right: "-5px",
                                cursor: "pointer",
                              }}
                            >
                              <img
                                src={IconDeltete}
                                alt="delete"
                                width={18}
                                height={18}
                              />
                            </span>
                          </div>
                        );
                    })}
                </div>
              )}
              <div>
                {isLoadingUploadImage && (
                  <Spinner
                    size="sm"
                    className="me-2"
                    style={{ color: "#4da3da" }}
                  ></Spinner>
                )}
              </div>

              <div>
                <Upload
                  {...props}
                  multiple={true}
                  beforeUpload={() => false}
                  fileList={[]}
                  onChange={async (info: any) => {
                    setIsLoadingUploadImage(true);
                    try {
                      const cloneInfo = info?.fileList?.length
                        ? [...info?.fileList]
                        : [];

                      const files = info.fileList;
                      const data = new FormData();
                      for (var i = 0; i < files?.length; i++) {
                        data.append("files", files[i]?.originFileObj);
                      }

                      const fileUpload = info.fileList;
                      const lstFileUpload = fileUpload?.map((item: any) => {
                        return {
                          filename: `bar-list/${item?.name}`,
                        };
                      });

                      const lstFileName = { list: lstFileUpload };
                      const pathImage: any = await createPathCloudFrame(
                        lstFileName
                      );

                      if (pathImage?.code === 200) {
                        const dataPutUpload = pathImage?.data;

                        dataPutUpload?.map(async (item: any, index: number) => {
                          const url: string = item?.url;
                          const fileName = `${process.env.REACT_APP_UPLOAD_URL}/${item?.filename}`;

                          const res = await putUpload({
                            url,
                            file: fileUpload?.[index]?.originFileObj,
                          });

                          if (res) {
                            formik.setFieldValue(`files.${index}`, {
                              url: fileName,
                              description: "Bar",
                            });
                          }
                        });
                        setIsLoadingUploadImage(false);
                      } else {
                        setIsLoadingUploadImage(false);
                      }
                    } catch (error: any) {
                      setIsLoadingUploadImage(false);
                      toast(
                        `${t(
                          "Input buffer contains unsupported image format"
                        )}`,
                        CONFIG_OPTION_TOAST_ERROR
                      );
                    }
                  }}
                  onRemove={() => {
                    //return onGalleryFileRemove();
                  }}
                >
                  <Button icon={<UploadOutlined />}>
                    {t("Click to Upload")}
                  </Button>
                </Upload>
                {formik.touched.files && formik?.errors?.files ? (
                  <div className="text-danger mt-2">
                    {formik?.errors?.files}
                  </div>
                ) : null}
              </div>
            </Col>

            <div className="col-lg-12">
              <div className="hstack gap-2 justify-content-end">
                <button
                  className="btn btn-primary fs-14"
                  color="success"
                  type="submit"
                  disabled={isLoading}
                  style={{ width: "120px" }}
                >
                  {isLoading ? (
                    <Spinner size="sm" className="me-2"></Spinner>
                  ) : (
                    <>{isEdit ? t("Button Update") : t("Button Create")}</>
                  )}
                </button>
                <button
                  className="btn btn-secondary fs-14"
                  color="light"
                  type="button"
                  onClick={onCloseClick}
                  disabled={isLoading}
                  style={{ width: "100px" }}
                >
                  {t("Button Close")}
                </button>
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}
